declare namespace $ {

	export class $mol_icon_align_horizontal_right extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=right.view.tree.d.ts.map